<template>
  <div class="four content">
    <div class="left-side slideUp">
      <router-link :to="{ name: 'ProjectThree' }">
        <img src="../assets/up-arrow.png" class="arrow arrow-up" />
      </router-link>
      <p class="notice-parragraph">
        💬 Usa las flechas para navegar entre mis proyectos
      </p>
      <h1>SMOOTHIES STORE</h1>

      <p class="subtxt">Tecnologías usadas:</p>
      <ul class="technologies">
        <li>Bootstrap 4</li>
        <li>HTML5</li>
        <li>CSS3</li>
      </ul>
      <a
        class="GithubLink"
        target="_blank"
        href="https://github.com/nicoleloupias/tienda-smoothies"
        ><font-awesome-icon :icon="['fab', 'github']" />Repositorio en Github</a
      >
      <a
        class="project-link"
        href="https://nicoleloupias.github.io/tienda-smoothies/"
        target="_blank"
        >Visitar la página</a
      >

      <router-link :to="{ name: 'ProjectThree' }">
        <div class="MobileLink">
          <p>Anterior proyecto</p>
          <img src="../assets/up-arrow.png" class="MobileLinkDecor" />
        </div>
      </router-link>
      <router-link :to="{ name: 'ProjectFive' }">
        <img src="../assets/down-arrow.png" class="arrow arrow-down" />
        <div class="MobileLink">
          <p>Siguiente proyecto</p>
          <img src="../assets/down-arrow.png" class="MobileLinkDecor" />
        </div>
      </router-link>
    </div>

    <div class="img2 right-side">
      <img src="../assets/smoothie.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectFour",
};
</script>

<style lang="scss" scoped>
$page_color: #c3b7c5;
h1 {
  color: $page_color !important;
}
.img2 {
  img {
    width: 70%;
  }
}

a.project-link::before {
  background-color: $page_color !important;
}

.technologies {
  margin-bottom: 50px;
}
</style>
